"use client";

import { useMemo } from "react";

import useTrustPilotReviewData from "@/hooks/use-trustpilot-review-data/use-trustpilot-review-data";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import { RenewalRightPanelPageDataType } from "@/types/renewals";

import RenewalRightPanelInfoCard from "../renewal-right-panel-info-card/renewal-right-panel-info-card";

type RightPanelProps = {
  pageData: RenewalRightPanelPageDataType;
};

export default function RightPanel({ pageData }: Readonly<RightPanelProps>) {
  const { expandedSections } = useRenewalStateContext();
  const { reviewData } = useTrustPilotReviewData(pageData.brandName);

  const activeSection = useMemo(() => {
    if (expandedSections.length === 0) return "policy-details";
    return expandedSections[expandedSections.length - 1];
  }, [expandedSections]);

  return (
    <RenewalRightPanelInfoCard
      testId="renewals-right-panel"
      activeSection={activeSection}
      pageData={pageData}
      reviewData={reviewData}
    />
  );
}
